import { FC } from 'react';

import styles from './BrandBackground.styles.m.css';

interface IBrandBackgroundSrc {
  light: string;
  dark?: string;
}

interface IBrandBackgroundProps {
  isDarkMode: boolean;
  backgroundSrc: IBrandBackgroundSrc;
}

export const BrandBackground: FC<IBrandBackgroundProps> = ({ isDarkMode, backgroundSrc }) => {
  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url(${isDarkMode ? backgroundSrc.dark : backgroundSrc.light})`,
      }}
    ></div>
  );
};
